import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { OperatorCompany } from '../operator-companies-state.model';

export const OperatorCompaniesActions = createActionGroup({
  source: 'Operator Companies',
  events: {
    'Load Companies': emptyProps(),
    'Load Companies Success': props<{ companies: OperatorCompany[] }>(),
    'Load Companies Failure': props<{ error: string }>(),
    'Reset State': emptyProps(),
  },
});
